import type { GridApi, RowDragEndEvent } from "@ag-grid-community/core";
import type { FacetTableData } from "./facet-table-helpers";
import { reorderTableRows } from "./facet-table-sort-helpers";

export function tableContentKey(table: FacetTableData): string {
    return JSON.stringify({ h: table.headers, r: table.rows });
}

export function readRowLabelsFromGrid(api: GridApi, labelField: string): string[] {
    const labels: string[] = [];
    const count = api.getDisplayedRowCount();
    for (let i = 0; i < count; i++) {
        const node = api.getDisplayedRowAtIndex(i);
        if (!node?.data) continue;
        labels.push(String(node.data[labelField] ?? ""));
    }
    return labels;
}

/** Read post-drag row order from the grid (same approach as column headers after column move). */
export function rowsAfterRowDragEvent(
    event: RowDragEndEvent,
    labelField: string,
    currentRows: Record<string, unknown>[]
): { rows: Record<string, unknown>[]; labels: string[] } {
    const labels = readRowLabelsFromGrid(event.api, labelField);
    if (labels.length === 0) {
        return { rows: currentRows, labels: [] };
    }
    const rows = reorderTableRows(
        { headers: labelField ? [labelField] : [], rows: currentRows },
        labels
    ).rows;
    return { rows, labels };
}
